import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
let url=`${app.URL}/org/fetchall`;
const searchOrganization = (search) => {
  let requestedSearch = search
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async (search) => {
      try {
        const res = await axios.get(`${app.URL}/org/search/${search}`);
        setResponse(res.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchData(requestedSearch);
  }, []);

  return { loading, response, error };
};

export default searchOrganization;
